import axiosInstance from '../../Config/axiosConfig';

export const getAffiliateDashboard = async () => {
  try {
    const response = await axiosInstance.get('/affiliate/home');
    
    if (!response.data.status) {
      throw new Error('Error fetching affiliate dashboard', response);
    }
    
    return response.data.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getAffiliateChart = async (year) => {
  try {
    const response = await axiosInstance.get('/affiliate/home/chart', {
      params: { year }
    });
    
    if (!response.data.status) {
      throw new Error('Error fetching affiliate chart', response);
    }
    
    return response.data.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getAffiliateProfile = async () => {
  try {
    const response = await axiosInstance.get('/affiliate/profile');
    
    if (!response.data.status) {
      throw new Error('Error fetching affiliate profile', response);
    }
    
    return response.data.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const updateAffiliateProfile = async (formData) => {
  try {
    const response = await axiosInstance.post('/affiliate/profile/update', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    if (!response.data.status) {
      throw new Error('Error updating affiliate profile', response);
    }
    
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const passwordUpdate = async (credentials) => {
  try {
    const response = await axiosInstance.post('/affiliate/change-password', credentials);
    if (!response.data.status) {
      throw new Error('Error updating affiliate password', response);
    }
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};
